const tbAppConstants = {
    mainNavBarElementId: "tbMainNavBar",
    loginInterceptState: "tbLoginInterceptState"
};

export default Object.freeze(tbAppConstants);


//////////////////
// WEBPACK FOOTER
// ./src/config/tbAppConstants.js
// module id = Wf1y
// module chunks = 1